import { render, staticRenderFns } from "./liveMatchesTwo_detail.vue?vue&type=template&id=f73517b2&scoped=true"
import script from "./liveMatchesTwo_detail.vue?vue&type=script&lang=js"
export * from "./liveMatchesTwo_detail.vue?vue&type=script&lang=js"
import style0 from "./liveMatchesTwo_detail.vue?vue&type=style&index=0&id=f73517b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73517b2",
  null
  
)

export default component.exports